import React from 'react';
import PropTypes from 'prop-types';

import ToolTip from 'zignal-landscape/lib/ToolTip';


function StoryCheckerDetailHighlightMatch(props) {
  const {
    styles, children,
    showTooltip = false,
    included = false, excludedByProfile = false, excludedByAccount = false,
    accountName = '', profileName = '',
  } = props;
  const reasons = [];
  let style;

  if (excludedByProfile || excludedByAccount) {
    style = styles.highlightExcluded;

    if (excludedByProfile) {
      reasons.push(<div key="excludedByProfile"><b>Excluded term</b> for {profileName} Dataset</div>);
    }
    if (excludedByAccount) {
      reasons.push(<div key="excludedByAccount"><b>Excluded term</b> for {accountName} Account</div>);
    }
  }
  else if (included) {
    style = styles.highlightIncluded;

    reasons.push(<div key="included"><b>Included term</b> for {profileName} Dataset</div>);
  }

  const content = (<span className={style}>{children}</span>);
  if (! showTooltip) {
    return content;
  }

  return (
    <ToolTip
      tooltipText={<div>{reasons}</div>}
      position="top"
      align="left"
    >{content}</ToolTip>
  );
}

StoryCheckerDetailHighlightMatch.propTypes = {
  styles: PropTypes.object,
  children: PropTypes.node,
  text: PropTypes.string.isRequired,
  nestingDepth: PropTypes.number.isRequired,
  showTooltip: PropTypes.bool,
  included: PropTypes.bool,
  excludedByProfile: PropTypes.bool,
  excludedByAccount: PropTypes.bool,
  accountName: PropTypes.string,
  profileName: PropTypes.string,
};


export default StoryCheckerDetailHighlightMatch;
